import { render, staticRenderFns } from "./customerContribution.vue?vue&type=template&id=81d6620c&scoped=true&"
import script from "./customerContribution.vue?vue&type=script&lang=js&"
export * from "./customerContribution.vue?vue&type=script&lang=js&"
import style0 from "./customerContribution.vue?vue&type=style&index=0&id=81d6620c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d6620c",
  null
  
)

export default component.exports